var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKpiUnavailable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 118 117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    d: "M59 0a58.5 58.5 0 1 1 0 117A58.5 58.5 0 0 1 59 0zm.5 80a21 21 0 1 0 0-42 21 21 0 0 0 0 42z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M94.7 84.3H31.2V26.8a.9.9 0 0 0-.8-.8h-5.1a.9.9 0 0 0-.8.8v63.4a.9.9 0 0 0 .8.8h69.4a.9.9 0 0 0 .8-.8v-5.1a.9.9 0 0 0-.8-.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 1,
    d: "M59.5 40.6a18.4 18.4 0 1 0 0 36.8 18.4 18.4 0 0 0 0-36.8zm-1.3 9.5c0-.1.1-.3.3-.3h2c.2 0 .3.2.3.3v11.2c0 .2-.1.3-.3.3h-2a.3.3 0 0 1-.3-.3V50.1zm1.3 18.1a2 2 0 0 1 0-4 2 2 0 0 1 0 4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiUnavailable);
export default __webpack_public_path__ + "static/media/kpi-unavailable.cdd26ab8.svg";
export { ForwardRef as ReactComponent };